import { LinearGradientProps } from 'react-native-svg'

export const getGradientBreakpoint = (
  index: number,
  total: number,
  start?: number, // <0-1>
  end?: number // <0-1>
) => {
  if (index === 0) return start || 0.1
  if (index === total - 1) return end || 0.9
  return index / total
}

export const linearGradientProps = {
  x1: '32',
  y1: '0',
  x2: '32',
  y2: '64',
  gradientUnits: 'userSpaceOnUse',
} satisfies LinearGradientProps
